'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rows = require('./rows');

var rows = _interopRequireWildcard(_rows);

var _selection = require('./selection');

var selection = _interopRequireWildcard(_selection);

var _expand = require('./expand');

var expand = _interopRequireWildcard(_expand);

var _mutate = require('./mutate');

var mutate = _interopRequireWildcard(_mutate);

var _sort = require('./sort');

var sort = _interopRequireWildcard(_sort);

var _type = require('./type');

var type = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = _extends({}, rows, selection, expand, mutate, sort, type);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-table-next/lib/src/store/operators.js
// module id = ./node_modules/react-bootstrap-table-next/lib/src/store/operators.js
// module chunks = main